import { EditableType, EditorType } from '../../constants';
import * as helpers from '../helpers';
import { MediaElement, VideoSettings, VideoParam, youtubeJsApiAttribute } from './typing';
import { EditableItem } from '../htmlEditor/constants';

export const isIframe = (type: EditableType, isExternalLinkActive: boolean): boolean => (
	type === EditableType.animation ||
	type === EditableType.video && isExternalLinkActive
);

const getImageElement = (htmlDocument: Document, src: string): HTMLImageElement => {
	const image = htmlDocument.createElement('img');
	image.src = src;

	return image;
};

const getAnimationElement = (editorType: EditorType, htmlDocument: Document, src: string, className?: string): HTMLIFrameElement => {
	const iframe = htmlDocument.createElement('iframe');

	if (editorType === EditorType.INDESIGN) {
		iframe.className = className as string;
	}

	iframe.src = src;
	iframe.setAttribute('frameborder', '0');
	iframe.setAttribute('width', '100%');
	iframe.setAttribute('height', '100%');
	iframe.setAttribute('allowFullScreen', 'true');

	return iframe;
};

const getVideoElement = (editorType: EditorType, htmlDocument: Document, src: string, videoSettings: VideoSettings, className?: string): HTMLVideoElement => {
	const video = htmlDocument.createElement('video');

	if (editorType === EditorType.HTML) {
		video.setAttribute(EditableItem.Video, '');
	} else {
		video.className = className as string;
	}

	video.setAttribute('width', '100%');
	video.setAttribute('height', '100%');

	// the plugin sets these on export and rebuilding the element here would otherwise drop them.
	// without playsinline an iPhone plays the video fullscreen
	video.setAttribute('playsinline', '');
	video.setAttribute('disablePictureInPicture', '');

	Object.keys(videoSettings).forEach((key) => {
		if (videoSettings[key]) {
			video.setAttribute(key, '');
		}
	});

	const source = htmlDocument.createElement('source');
	source.src = src;
	source.type = 'video/mp4';

	video.appendChild(source);

	return video;
};

const getIframeElement = (editorType: EditorType, htmlDocument: Document, src: string, videoSettings: VideoSettings, className?: string): HTMLIFrameElement => {
	const iframe = htmlDocument.createElement('iframe');

	if (editorType === EditorType.HTML) {
		iframe.setAttribute(EditableItem.Video, '');
	} else {
		iframe.className = className as string;
	}

	let modifiedSrc = src.split('?')[0]; // remove query params
	modifiedSrc = `${modifiedSrc}?${youtubeJsApiAttribute}`;

	Object.keys(videoSettings).forEach((key) => {
		const attributeName = key === VideoParam.muted ? 'mute' : key;
		modifiedSrc += `&${attributeName}=${getYoutubeAttributeValue(videoSettings[key])}`;
	});

	iframe.src = modifiedSrc;
	iframe.setAttribute('frameborder', '0');
	iframe.setAttribute('width', '100%');
	iframe.setAttribute('height', '100%');
	iframe.setAttribute('allowFullScreen', 'true');

	return iframe;
};

const getYoutubeAttributeValue = (attribute: string): number => attribute ? 1 : 0;

export const getElement = (
	editorType: EditorType,
	type: EditableType,
	isExternalLinkActive: boolean,
	htmlDocument: Document,
	src: string,
	videoSettings?: VideoSettings,
	isVisible?: boolean,
	className?: string,
): MediaElement => {
	let element: MediaElement;

	switch (type) {
		case EditableType.animation:
			element = getAnimationElement(editorType, htmlDocument, src, className);
			break;
		case EditableType.video:
			element = isExternalLinkActive
				? getIframeElement(editorType, htmlDocument, src, videoSettings as VideoSettings, className)
				: getVideoElement(editorType, htmlDocument, src, videoSettings as VideoSettings, className);
			break;
		case EditableType.image:
		default:
			element = getImageElement(htmlDocument, src);
	}

	if (isVisible === false) {
		helpers.setElementIsHidden(element);
	}

	return element;
};

export const getDriveLinkWithoutHash = (driveLink: string): string => driveLink.split('?')[0];

export const setTooltipActions = (element: HTMLElement, tooltip: string, isTooltipActive: boolean): void => {
	if (isTooltipActive) {
		element.setAttribute('onmouseenter', helpers.getTooltipAction(helpers.TooltipAction.SHOW, tooltip));
		element.setAttribute('onmouseleave', helpers.getTooltipAction(helpers.TooltipAction.HIDE));
	} else {
		element.removeAttribute('onmouseenter');
		element.removeAttribute('onmouseleave');
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/editableMedia/saveData.ts